import * as React from 'react'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation()
  return (
    <div className='mx-auto max-w-md rounded-xl border bg-background p-8 text-center'>
      <h1 className='text-xl font-semibold'>{t('Scheduling::This booking page does not exist')}</h1>
      <p className='mt-2 text-muted-foreground'>{t('Scheduling::Check the link or contact the person who shared it.')}</p>
    </div>
  )
}
